import { render, staticRenderFns } from "./VButtonIcon.vue?vue&type=template&id=69835e7a&"
import script from "./VButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./VButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonIcon.vue?vue&type=style&index=0&id=69835e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports